import { UseMutationOptions, useMutation } from '@tanstack/react-query'
import { AuthenticationToken } from '@mindfulchefuk/api-client'
import { setToken } from '@mindfulchefuk/helpers/tokens/setToken'

type SignInResponse = {
  customerId: string
  accessToken: string
}

type TSignInArgs = {
  email: string
  password: string
}

export const signIn = async ({
  email,
  password,
}: TSignInArgs): Promise<SignInResponse> => {
  const getLoginToken = new AuthenticationToken({
    email: email.toLowerCase(),
    password,
  })

  await getLoginToken.save()

  const { customer_id: customerId, access_token: accessToken } = getLoginToken

  if (accessToken) {
    setToken(accessToken)
  }

  return { customerId, accessToken }
}

export const useMutationSignIn = (
  mutateOptions: UseMutationOptions<SignInResponse, unknown, TSignInArgs> = {}
) => {
  return useMutation({
    mutationFn: ({ email, password }: TSignInArgs) =>
      signIn({ email, password }),
    ...mutateOptions,
  })
}
